import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import AppSelect from '../../components/common/AppSelect';

function ModulosFormPage() {
  // Estados do formulário
  const [nome, setNome] = useState('');
  const [unidadeId, setUnidadeId] = useState('');

  // Estado para carregar a lista de Unidades
  const [unidades, setUnidades] = useState([]);

  // Estados de controle
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  const pageTitle = id ? 'Editar Módulo' : 'Novo Módulo';
  const pageSubtitle = id ? `Editando o registro #${id}` : 'Preencha os dados para criar um novo módulo';
  const unidadeOptions = unidades.map((unidade) => ({
    value: String(unidade.id),
    label: unidade.nome,
  }));

  // Efeito para buscar dados (Módulo específico e lista de Unidades)
  useEffect(() => {
    // Função para buscar a lista de unidades para o select
    const fetchUnidades = async () => {
      try {
        const response = await api.get('/unidades', {
          params: {
            per_page: 10000,
            status: 'active',
          },
        });
        setUnidades(response.data?.data ?? []);
      } catch (err) {
        setError('Não foi possível carregar a lista de unidades.');
        console.error(err);
      }
    };

    // Função para buscar o módulo em caso de edição
    const fetchModulo = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/modulos/${id}`);
        const { nome, unidade_id } = response.data.data;
        setNome(nome);
        setUnidadeId(unidade_id);
      } catch (err) {
        setError('Não foi possível carregar os dados do módulo.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUnidades();
    if (id) {
      fetchModulo();
    }
  }, [id]);

  // Manipulador para o envio do formulário
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    const moduloData = {
      nome,
      unidade_id: unidadeId
    };

    try {
      if (id) {
        await api.put(`/modulos/${id}`, moduloData);
      } else {
        await api.post('/modulos', moduloData);
      }
      navigate('/painel/modulos');
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('Ocorreu um erro ao salvar o módulo. Verifique os dados.');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading && id) {
    return (
      <div className="modulos-form-page">
        <LoadingSpinner text="Carregando dados do módulo..." />
      </div>
    );
  }

  return (
    <div className="modulos-form-page">
      <div className="content-header">
        <h1 className="content-title">{pageTitle}</h1>
        <p className="content-subtitle">{pageSubtitle}</p>
      </div>

      <div className="card modulos-form-card">
        <div className="card-body">
          <form className="modulos-form" onSubmit={handleSubmit}>
            {error && <div className="alert alert-danger">{error}</div>}

            <fieldset className="modulos-form-section">
              <div className="mb-3">
                <label htmlFor="nome" className="form-label">Nome do Módulo</label>
                <input
                  type="text"
                  className="form-control"
                  id="nome"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label htmlFor="unidadeId" className="form-label">Unidade</label>
                <AppSelect
                  className="form-app-select"
                  ariaLabel="Unidade"
                  options={unidadeOptions}
                  value={String(unidadeId || '')}
                  onChange={setUnidadeId}
                  placeholder="Selecione uma unidade..."
                />
              </div>
            </fieldset>

            <div className="modulos-form-actions d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => navigate('/painel/modulos')}
                disabled={loading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ModulosFormPage;
